/**
 * User status mapping utilities
 *
 * Maps numeric user status codes to human-readable strings
 */

export const USER_STATUS_MAP: Record<number, string> = {
  0: 'NEW',
  1: 'Completed Without Password',
  2: 'Completed',
};

/**
 * Formats a user status code into a human-readable string
 *
 * @param status - Numeric status code
 * @returns Human-readable status string or "Unknown (code)" if status is not recognized
 *
 * @example
 * ```typescript
 * formatUserStatus(1) // Returns "Completed"
 * formatUserStatus(999) // Returns "Unknown (999)"
 * ```
 */
export const formatUserStatus = (status: number): string => {
  return USER_STATUS_MAP[status] || `Unknown (${status})`;
};
